import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetUserStripeConnectedAccountMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  stripe_connected_account_id: Types.Scalars['String'];
}>;


export type SetUserStripeConnectedAccountMutation = { __typename?: 'Mutation', adminUpdateUser?: { __typename?: 'User', id: string, stripe_connected_account_id?: string | null } | null };


export const SetUserStripeConnectedAccountDocument = gql`
    mutation SetUserStripeConnectedAccount($id: ID!, $stripe_connected_account_id: String!) {
  adminUpdateUser(
    id: $id
    item: {stripe_connected_account_id: $stripe_connected_account_id}
  ) {
    id
    stripe_connected_account_id
  }
}
    `;
export type SetUserStripeConnectedAccountMutationFn = Apollo.MutationFunction<SetUserStripeConnectedAccountMutation, SetUserStripeConnectedAccountMutationVariables>;

/**
 * __useSetUserStripeConnectedAccountMutation__
 *
 * To run a mutation, you first call `useSetUserStripeConnectedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserStripeConnectedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserStripeConnectedAccountMutation, { data, loading, error }] = useSetUserStripeConnectedAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stripe_connected_account_id: // value for 'stripe_connected_account_id'
 *   },
 * });
 */
export function useSetUserStripeConnectedAccountMutation(baseOptions?: Apollo.MutationHookOptions<SetUserStripeConnectedAccountMutation, SetUserStripeConnectedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserStripeConnectedAccountMutation, SetUserStripeConnectedAccountMutationVariables>(SetUserStripeConnectedAccountDocument, options);
      }
export type SetUserStripeConnectedAccountMutationHookResult = ReturnType<typeof useSetUserStripeConnectedAccountMutation>;
export type SetUserStripeConnectedAccountMutationResult = Apollo.MutationResult<SetUserStripeConnectedAccountMutation>;
export type SetUserStripeConnectedAccountMutationOptions = Apollo.BaseMutationOptions<SetUserStripeConnectedAccountMutation, SetUserStripeConnectedAccountMutationVariables>;